import i18n from "i18n/i18n";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as RoundedbackSvg } from "assets/Svgs/RoundedBack.svg";
import {
  Button,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  SelectChangeEvent,
  Tooltip,
} from "@mui/material";
import { useEffect, useState } from "react";
import GenericAttachment from "components/GenericAttachments";
import { useBoundStore } from "store/store";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";

const getDateFromTimestamp = (unixTimeStamp: any) => {
  let date = new Date(unixTimeStamp);
  return (
    date.getFullYear() +
    "-" +
    (date.getMonth() + 1 <= 9
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) +
    "-" +
    (date.getDate() <= 9 ? "0" + date.getDate() : date.getDate())
  );
};
const getTimeFromTimestamp = (unixTimeStamp: any) => {
  let date = new Date(unixTimeStamp);
  return (
    date.getHours() +
    ":" +
    (date.getMinutes() <= 9 ? "0" + date.getMinutes() : date.getMinutes())
  );
};

function CreateNotification(props: any) {
  const location = useLocation();
  const navigate = useNavigate();

  let fromMachine = location?.state?.fromMachine;
  const getAllMaintenanceCategories = useBoundStore(
    (state) => state.getAllMaintenanceCategories
  );

  useEffect(() => {
    getAllMaintenanceCategories();
  }, []);

  useEffect(() => {
    if (location?.state?.fromMachine == true) {
      
      initDataForSelectedEquipment(location?.state?.equipmentNodeId);
    } else {
     
    }
  }, [location.state]);

  const [equipmentName, setEquipmentName] = useState<any>(location?.state?.data?.equipment?.name);
  const [equipmentpoolName, setEquipmentpoolName] = useState<any>();
  const [title, setTitle] = useState("");
  const [siteName, setSiteName] = useState<any>();
  const [areaName, setAreaName] = useState<any>();
  const [type, setType] = useState(
    location?.state?.notificationData?.type
      ? location?.state?.notificationData?.type
      : 0
  );

  const [date, setDate] = useState();
  const [status, setStatus] = useState(
    location?.state?.notificationData?.status
      ? location?.state?.notificationData?.status
      : "0"
  );
  const [time, setTime] = useState<any>(dayjs());
  const [category, setcategory] = useState("");
  

  const getSiteOfEquipment = useBoundStore((state) => state.getSiteOfEquipment);
  const getAreaOfEquipment = useBoundStore((state) => state.getAreaOfEquipment);
  const getEquipmentpoolOfEquipment = useBoundStore(
    (state) => state.getEquipmentpoolOfEquipment
  );

  const creation_date: any = getDateFromTimestamp(
    location?.state?.notificationData?.created
  );
  const creation_time: any = getTimeFromTimestamp(
    location?.state?.notificationData?.created
  );

  useEffect(() => {
    if (location?.state?.isEditMode == true) {
  
      setTitle(location?.state?.notificationData?.title);
      setStatus(location?.state?.notificationData?.status);
      setDate(creation_date);
      setSiteName(
        location?.state?.notificationData?.isnotificationof[0]?.equipment
          ?.isequipmentof[0]?.area?.isareaof[0]?.site?.name
      );
      setAreaName(
        location?.state?.notificationData?.isnotificationof[0]?.equipment
          ?.isequipmentof[0]?.area?.name
      );

      setEquipmentName(
        location?.state?.notificationData?.isnotificationof[0].equipment.name
      );

      let n_date = location?.state?.notificationData?.created;
      const date = new Date(n_date);

      //format Time
      const year = date.getUTCFullYear();
      const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
      const day = date.getUTCDate().toString().padStart(2, "0");
      const hours = date.getUTCHours().toString().padStart(2, "0");
      const minutes = date.getUTCMinutes().toString().padStart(2, "0");
      const seconds = date.getUTCSeconds().toString().padStart(2, "0");
      const milliseconds = date
        .getUTCMilliseconds()
        .toString()
        .padStart(3, "0");

      const formattedDateString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
      const timeAsDayjs = dayjs(new Date(formattedDateString));
      setTime(timeAsDayjs);
    }
  }, [location.state]);

  const initDataForSelectedEquipment = async (equipmentNodeId: any) => {
    // get the site of the equipment
    const site = getSiteOfEquipment(equipmentNodeId);
    if (site != null) {
      setSiteName(site.name);
    } else {
      setSiteName(null);
    }

    // get the area of the equipment
    const area = getAreaOfEquipment(equipmentNodeId);
    if (area != null) {
      setAreaName(area.name);
    } else {
      setAreaName(null);
    }

    // get the equipmentpool of the equipment
    const equipmentpool = getEquipmentpoolOfEquipment(equipmentNodeId);
    if (equipmentpool != null) {
      setEquipmentpoolName(equipmentpool.name);
    } else {
      setEquipmentpoolName(null);
    }

  };

  const maintenanceCategories: any = useBoundStore(
    (state) => state.maintenanceCategories
  );
  const StandardMaintenanceCategories = Array.isArray(maintenanceCategories)
    ? maintenanceCategories.map((item) => ({
        title: item.maintenancecategory.name,
        value: item.maintenancecategory.nodeid,
        colorcode: item.maintenancecategory.colorcode,
      }))
    : [];

  const [dropdownMaintenanceCategory, setDropdownMaintenanceCategory] =
    useState(StandardMaintenanceCategories);

  const [image_data, set_image_data] = useState([]);
  const [video_data, set_video_data] = useState([]);
  const [docs_data, set_docs_data] = useState([]);

  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value);
  };

  const handleType = (e: any) => {
    setType(e.target.value);
  };
  const handleStatus = (e: any) => {
    setStatus(e.target.value);
  };
  const handleDate = (e: any) => {
    setDate(e.target.value);
  };
  const handleCategories = (event: SelectChangeEvent<string>) => {
    const selectedValue = event?.target?.value;
    setcategory(selectedValue);
  };

  const receiveChildValueAttachment = (images: any, videos: any, docs: any) => {
    set_image_data(images);
    set_video_data(videos);
    set_docs_data(docs);
  };

  const formatDate = (datee: any) => {
    const date = new Date(datee);

    // Get year, month, and day
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // getMonth() returns 0-11
    const day = date.getDate();

    // Format month and day to always be two digits
    const formattedMonth = month.toString().padStart(2, "0");
    const formattedDay = day.toString().padStart(2, "0");

    // Combine into final formatted string
    const formattedDate = `${year}-${formattedMonth}-${formattedDay}`;
    return formattedDate;
  };

  const lang: any = useBoundStore((state) => state.lang);

  const [helperTextTitle, sethelperTextTitle] = useState(
    i18n(lang)?.noti_title_helpertext
  );


  return (
    <>
      <div
        className="breadcrumpsWrapper"
        onClick={() => {
          navigate("/machine-detail", {
            state: {
              machineNodeId: location?.state?.equipmentNodeId
                ? location?.state?.equipmentNodeId
                : location?.state?.notificationData?.isnotificationof[0]
                    .equipment.nodeid,
            },
          });
        }}
      >
        <div className="backIcon">
          <RoundedbackSvg />
        </div>
        <div className="breadcrumps">{i18n(lang)?.machine_detail}</div>
      </div>
      <section>
          <Paper>
            <div style={{ padding: "24px" }}>
              <header style={{ margin: "0px 0px 20px 0px" }}>
                <Grid
                  container
                  spacing={3}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Grid item>
                    <Typography variant="h6">
                      

                      {location?.state?.isEditMode ? i18n(lang)?.edit_notification : i18n(lang)?.new_notification}
                    </Typography>
                  </Grid>
                </Grid>
              </header>

              <Grid
                container
                spacing={3}
                direction="row"
                justifyContent="space-between"
              >
                <Grid item xs={10}>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      {location?.state?.isEditMode || fromMachine ? (
                        <TextField
                          id="text"
                          fullWidth
                          label={i18n(lang)?.new_report_title_2_select_1_label}
                          value={siteName}
                          type="text"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{ readOnly: true }} // Add this line to make the text field read-only
                          variant="outlined"
                        />
                      ) : (
                        <FormControl fullWidth>
                          <InputLabel id="demo1-simple-select-label">
                            {i18n(lang)?.new_report_title_2_select_1_label}
                          </InputLabel>
                          <Select
                            labelId="maintenance_category"
                            id="categoryID"
                            value={siteName}
                            onChange={handleCategories}
                            label={i18n(lang)?.sites}
                          >
                            <MenuItem value={"11"}>{11}</MenuItem>
                            <MenuItem value={"12"}>{12}</MenuItem>
                            <MenuItem value={"13"}>{13}</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </Grid>
                    <Grid item xs={6}>
                      {location?.state?.isEditMode || fromMachine ? (
                        <Tooltip title={"" + equipmentName + " (" + areaName + ")"} placement="right-end">
                          <TextField
                            id="text"
                            fullWidth
                            label={i18n(lang)?.applicable_device}
                            value={equipmentName + " (" + areaName + ")"}
                            type="text"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ readOnly: true }} // Add this line to make the text field read-only
                            variant="outlined"
                          />
                        </Tooltip>
                      ) : (
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel id="maintenance_category">
                            {i18n(lang)?.applicable_device}
                          </InputLabel>
                          <Select
                            labelId="maintenance_category"
                            id="categoryID"
                            value={category}
                            onChange={handleCategories}
                            label={i18n(lang)?.applicable_device}
                          >
                            <MenuItem value={"11"}>{11}</MenuItem>
                            <MenuItem value={"12"}>{12}</MenuItem>
                            <MenuItem value={"13"}>{13}</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} sx={{ padding: "24px 0px" }}>
                    <Grid item xs={6}>
                        <TextField
                          id="text"
                          fullWidth
                          label={i18n(lang)?.notification_title}
                          value={title}
                          onChange={handleTitleChange}
                          type="text"
                          helperText={helperTextTitle}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                          error={title===""}
                        />
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel id="maintenance_repetition">
                          {i18n(lang)?.notificationtype}
                        </InputLabel>
                        <Select
                          labelId="maintenance_repetition"
                          onChange={handleType}
                          label={i18n(lang)?.notificationtype}
                          value={type}
                        >
                          {i18n(lang).dropdownNotificationType.map(
                            (type: any, index: any) => (
                              <MenuItem key={index} value={type.value}>
                                {type.title}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel id="maintenance_reminder">
                          {i18n(lang)?.problem_solution_status}
                        </InputLabel>
                        <Select
                          labelId="maintenance_repetition"
                          onChange={handleStatus}
                          label={i18n(lang)?.problem_solution_status}
                          value={status}
                        >
                          {i18n(lang).dropdownSolutionStatus?.length > 0 ? (
                            i18n(lang).dropdownSolutionStatus?.map(
                              (x: any, key: any) => {
                                return (
                                  <MenuItem value={x.value}>{x.title}</MenuItem>
                                );
                              }
                            )
                          ) : (
                            <option></option>
                          )}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                      <Grid>
                        <div className="dateField">
                          <TextField
                            id="date"
                            fullWidth
                            label={i18n(lang)?.date}
                            value={date}
                            defaultValue={formatDate(Date.now())}
                            onChange={handleDate}
                            type="date"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            variant="outlined"
                          />
                        </div>
                      </Grid>
                    </Grid>

                    <Grid item xs={3}>
                      <FormControl fullWidth>
                        <div className="new_notification_time">
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={["TimePicker"]}>
                              <DemoItem
                              >
                                <TimePicker
                                  value={time}
                                  onChange={(newValue) => setTime(newValue)}
                                  ampm={false} // Set ampm prop to false for 24-hour format
                                />
                              </DemoItem>
                            </DemoContainer>
                          </LocalizationProvider>
                        </div>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
            <Divider sx={{ margin: "24px 0px 0px 0px" }} />

            <div style={{ padding: "24px" }}>
              <GenericAttachment
                compTitle={i18n(lang)?.desc_planned_aintenance}
                fromChildToParentCallback={receiveChildValueAttachment}
                noBack
                noPaperBtn
                fromNotification
                customSaveBtn
                noPaper
                // diagnoseInformation
                date={date}
                time={time}
                type={type}
                status={status}
                title={title}
                nodeid={location?.state?.equipmentNodeId}
                notification={location?.state?.notificationData}
                edit={location?.state?.isEditMode}
              />
            </div>
          </Paper>
      </section>
    </>
  );
}
export default CreateNotification;
